import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastCloseArgs, ToastComponent, ToastPositionModel } from '@syncfusion/ej2-angular-notifications';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import { NgxSpinnerService } from 'ngx-spinner';
import { IncidentReportService } from 'src/app/core/services/IncidentReport/incident-report.service';
import { ToastService } from 'src/app/core/services/taoastService/toast-service.service';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';

@Component({
    selector: 'app-create-pin',
    templateUrl: './create-pin.component.html',
    styleUrls: ['../anonymous-dialog-signin/anonymous-dialog-signin.component.scss', './create-pin.component.scss'],
    standalone: false
})
export class CreatePinComponent implements OnInit {
  @ViewChild('toasttype')
  private toastObj: ToastComponent;
  public position: ToastPositionModel = { X: 'Right' };
  pinForm: UntypedFormGroup;
  caseNoMinPinLength = GlobalConstants.CaseNoMinPinLength;
  submitted = false;
  DialogObj: any;
  public today: Date = new Date();
  createPinSuccessfullyMessage = GlobalConstants.createPinSuccessfullyMessage;
  respondCreatePinNotes = GlobalConstants.RespondCreatePinNotes;
  constructor(
    private toastService: ToastService,
    private formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private incidentReportService: IncidentReportService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    setCulture('en-US');
    L10n.load({
      'en-US': {
        grid: {
          EmptyRecord: GlobalConstants.loadingGridMessage,
        },
        pager: {
          currentPageInfo: '',
          totalItemsInfo: '{1} to {2} of {0}',
        },
      },
    });
    this.initializeForm();
  }

  @HostListener('window:load')
  onLoad() {
    document.getElementById('e-pre-login-form-box').style.maxHeight = document.getElementById('prelogin-left-image').clientHeight + 'px';
  }
  @HostListener('window:resize')
  onResize() {
    document.getElementById('e-pre-login-form-box').style.maxHeight = document.getElementById('prelogin-left-image').clientHeight + 'px';
  }

  initializeForm() {
    this.pinForm = this.formBuilder.group(
      {
        UserName: ['', [Validators.required, Validators.email]],
        CaseNumber: ['', Validators.required],
        NewPin: ['', [Validators.required, Validators.minLength(this.caseNoMinPinLength)]],
        ConfirmPin: ['', [Validators.required, Validators.minLength(this.caseNoMinPinLength)]]
      },
      {
        validator: [this.confPins]
      }
    );
  }

  get formControl() {
    return this.pinForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    const pinModel = this.pinForm.value;
    if (this.pinForm.valid) {
      this.spinner.show('customSpinner');
      const pinViewModel = {
        UserName: pinModel.UserName,
        CaseNumber: pinModel.CaseNumber,
        NewPin: pinModel.NewPin,
      };
      this.incidentReportService.CreatePin(pinViewModel).subscribe(
        (result) => {
          this.spinner.hide('customSpinner');
          this.toastObj.show({
            content: this.createPinSuccessfullyMessage,
            cssClass: 'e-toast-success', icon: 'e-success toast-icons'
          });
          setTimeout(() => {
            this.GoToRespond();
          }, 2000);
        },
        error => {
          this.spinner.hide('customSpinner');
          this.toastObj.show({ content: error.error.InnerException.Message, cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
        });
    }
  }

  GoToRespond() {
    if (this.DialogObj) {
      this.DialogObj.hide();
    }
    this.router.navigate(['/respond']);
  }

  confPins(group: UntypedFormGroup) {
    const newPin = group.controls.NewPin.value;
    const confirmPin = group.controls.ConfirmPin.value;
    return newPin === confirmPin ? null : { notSame: true };
  }

  onBeforeOpen(e) {
    if (this.toastObj.element.children.length > 0) {
      if (e.options.content == this.toastService.getToastContent()) {
        e.cancel = true;
      }
    } else {
      this.toastService.setToastContent(e.options.content);
    }
  }

  close(e: ToastCloseArgs) {
    this.toastService.setToastStatus(false);
  }
}
